import { Component } from "@builder.io/sdk";

export const footerCiAppConfig: Component = {
  name: "Footer CI App",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "footer",
      advanced: true,
      helperText: "HTML ID attribute for the footer element",
    },
    {
      name: "className",
      type: "string",
      advanced: true,
      helperText: "Additional CSS classes to apply to the footer",
    },
    {
      name: "helpCenter",
      type: "object",
      defaultValue: {
        title: "Help Center",
        description: "Get started faster with tips and how-tos.",
        linkText: "Learn More",
        linkUrl: "#",
      },
      helperText: "Help center information and link",
      subFields: [
        {
          name: "title",
          type: "string",
          helperText: "Title for the help center section",
        },
        {
          name: "description",
          type: "string",
          helperText: "Brief description of the help center",
        },
        {
          name: "linkText",
          type: "string",
          helperText: "Text for the help center link",
        },
        {
          name: "linkUrl",
          type: "string",
          helperText: "URL for the help center link",
        },
      ],
    },
    {
      name: "videoTutorials",
      type: "object",
      defaultValue: {
        title: "Video Tutorials",
        description: "See it in action with quick walkthroughs.",
        linkText: "Watch Videos",
        linkUrl: "#",
      },
      helperText: "Video tutorials information and link",
      subFields: [
        {
          name: "title",
          type: "string",
          helperText: "Title for the video tutorials section",
        },
        {
          name: "description",
          type: "string",
          helperText: "Brief description of the video tutorials",
        },
        {
          name: "linkText",
          type: "string",
          helperText: "Text for the video tutorials link",
        },
        {
          name: "linkUrl",
          type: "string",
          helperText: "URL for the video tutorials link",
        },
      ],
    },
  ],
};
